import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TextFieldComponent from '../../../components/inputs/Textfield/TextfieldComponent';
import { useAppDispatch } from '../../../hooks/hooks';
import { resetPaymentMethodData } from '../../../redux/slices/finance/paymentMethod';
import { RootState } from '../../../redux/store';
import { routes } from '../../../routes';
import { updatePaymentMethod } from '../../../services/finance/paymentMethods';
import { PaymentMethodType } from '../../../types/Finance';
import { CreatePaymentMethodFormValidation } from './CreatePaymentMethodFormValidation';
export const UpdatePaymentMethod= ()=> {
  const dispatch = useAppDispatch();
  const paymentMethodData = useSelector((state: RootState) => state.paymentMethod);
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: updatePaymentMethod, mutationKey: 'updatePaymentMethod' });
  const { control, handleSubmit, formState: { errors } } = useForm<PaymentMethodType>
    (
      {
        resolver: yupResolver(CreatePaymentMethodFormValidation),
        defaultValues:paymentMethodData,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Actualizado!");
        handleBack();
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  const handleBack = () => {
    dispatch(resetPaymentMethodData());
    navigate(routes.paymentMethods);
  }
  return (

    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
            <TextFieldComponent name="description" label="Descrição" control={control} errors={errors} fieldProps={{ placeholder: 'Descrição' }} required={true}/>
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading}>
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}